import { render, staticRenderFns } from "./ProposalDetail.vue?vue&type=template&id=790f90fa"
import script from "./ProposalDetail.vue?vue&type=script&lang=js"
export * from "./ProposalDetail.vue?vue&type=script&lang=js"
import style0 from "./ProposalDetail.vue?vue&type=style&index=0&id=790f90fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports